import { useRef } from 'react';
import { SLUG_MAP, FRONT_BODY, BACK_BODY, BODY_ONLY } from '../constants/muscleDiagram';

let _muscleId = 0;

export default function MuscleDiagram({ primary = [], secondary = [], color = "#4f8fff", size = "compact" }) {
  const id = useRef(null);
  if (id.current === null) id.current = ++_muscleId;

  const maxW = size === "compact" ? 500 : 680;
  const inactive = "#111c35";
  const bodyOnly = "#0d1628";
  const div = "#06090f";

  const primarySlugs = new Set();
  const secondarySlugs = new Set();
  primary.forEach(m => { const s = SLUG_MAP[m]; if (s) primarySlugs.add(s); });
  secondary.forEach(m => { const s = SLUG_MAP[m]; if (s && !primarySlugs.has(s)) secondarySlugs.add(s); });

  function fillFor(slug) {
    if (BODY_ONLY.has(slug)) return bodyOnly;
    if (primarySlugs.has(slug)) return color;
    if (secondarySlugs.has(slug)) return color + "65";
    return inactive;
  }

  function renderBody(data, prefix) {
    return data.flatMap(part => {
      const fc = fillFor(part.slug);
      const paths = [
        ...(part.path.common || []),
        ...(part.path.left || []),
        ...(part.path.right || []),
      ];
      return paths.map((d, i) => (
        <path key={`${prefix}-${part.slug}-${i}`} d={d} fill={fc} stroke={div} strokeWidth="1.5"/>
      ));
    });
  }

  return (
    <svg viewBox="40 92 1360 1318" style={{ width: "100%", maxWidth: maxW, display: "block", margin: "0 auto" }}>
      {renderBody(FRONT_BODY, "f")}
      {renderBody(BACK_BODY, "b")}
      <text x="370" y="1406" textAnchor="middle" fontSize="44" fill="rgba(255,255,255,0.28)" fontFamily="sans-serif" fontWeight="600">FRONT</text>
      <text x="1100" y="1406" textAnchor="middle" fontSize="44" fill="rgba(255,255,255,0.28)" fontFamily="sans-serif" fontWeight="600">BACK</text>
    </svg>
  );
}
